import { render, staticRenderFns } from "./InvalidPostDialog.vue?vue&type=template&id=fd843e28&"
import script from "./InvalidPostDialog.vue?vue&type=script&lang=ts&"
export * from "./InvalidPostDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports